const allwainstance = { data: [], loading: true };
export const GetWAInstance = (state = allwainstance, action) => {
  switch (action.type) {
    case "get_wainstance":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
